module.exports = __webpack_public_path__ + "static/media/lateral-nonflexion-up-4.7653c7ca.png";